import { FilterType, ListingPageUrlState } from '../../../../redux/products/types';
import {
    INDEXABLE_PAGE_MULTIPLE_FILTERS_UPPER_LIMIT,
    INDEXABLE_PATH_FILTERS_SUM_UPPER_LIMIT,
    SEO_CONSTANTS,
} from './constant';
import { createSeoDecisionObject } from './createSeoDecisionObject';

export const computeSeoIndexableAndFollow = (listingPageState: ListingPageUrlState) => {
    const { appliedFilters = [], page = 1, query = {} } = listingPageState;
    const queryFilters = appliedFilters.filter(filter => filter.type === FilterType.query);
    const isQueryParamsEmpty = Object.keys(query).length === 0;
    const isQueryFiltersEmpty = queryFilters.length === 0;
    const { isFollow, indexableFiltersSum } = createSeoDecisionObject(listingPageState);

    const hasNoActiveFiltersViolation = indexableFiltersSum <= INDEXABLE_PATH_FILTERS_SUM_UPPER_LIMIT;
    const isPageIndexableFromMultipleFilter =
        indexableFiltersSum <= 1 || page <= INDEXABLE_PAGE_MULTIPLE_FILTERS_UPPER_LIMIT;

    if (
        hasNoActiveFiltersViolation &&
        isPageIndexableFromMultipleFilter &&
        isFollow &&
        isQueryFiltersEmpty &&
        isQueryParamsEmpty
    ) {
        return SEO_CONSTANTS.indexable;
    }
    return SEO_CONSTANTS.noIndexable;
};
